import * as types from '@/store/mutation-types/';

const mutations = {
  /**
   * @param {Object} state
   * @param {Object} data
   */
  [types.FAIL](state, data) {
    state.error = data;
  },
  /**
   * @param {Object} state
   * @param {Object} data
   */
  [types.SUCCESS](state, data) {
    if (data.result) {
      state.success++;
    } else {
      state.error = data.error;
    }
  },
  /**
   * @param {Object} state
   * @param {Boolean} data
   */
  [types.LOADER](state, data) {
    state.loader = data;
  },
};

export default mutations;
